var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"liquor-food-wine"},[_c('Header',{attrs:{"active":"/liquor/browser"}}),_c('HeaderSelect',{attrs:{"active":"browser","list":_vm.headerSelectArray}}),_c('NoContent'),_c('Sticky')],1)}
var staticRenderFns = []

export { render, staticRenderFns }